var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg88(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 80,
    viewBox: "0 0 99 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7475_55003)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.9414,
    y: 49,
    width: 30,
    height: 30,
    rx: 15,
    transform: "rotate(90 37.9414 49)",
    fill: "#F1EDF7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.5873,
    cy: 9.64706,
    rx: 2.64706,
    ry: 2.64706,
    transform: "rotate(90 80.5873 9.64706)",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 5.5,
    rx: 5.5,
    ry: 5.5,
    transform: "rotate(90 17.5 5.5)",
    fill: "#EB3366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 24H38C35.7909 24 34 25.7909 34 28V36C34 38.2091 35.7909 40 38 40H46C48.2091 40 50 38.2091 50 36V28C50 25.7909 48.2091 24 46 24Z",
    stroke: "url(#paint0_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 50V56H40",
    stroke: "url(#paint1_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 56V50H44",
    stroke: "url(#paint2_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 30H60V24",
    stroke: "url(#paint3_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 44V38H60",
    stroke: "url(#paint4_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 50V56H66",
    stroke: "url(#paint5_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 16H70C71.0608 16 72.0784 16.4214 72.8284 17.1716C73.5784 17.9217 74 18.9391 74 20V28",
    stroke: "url(#paint6_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 28V20C26 18.9391 26.4214 17.9217 27.1716 17.1716C27.9217 16.4214 28.9391 16 30 16H38",
    stroke: "url(#paint7_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 64H70C71.0608 64 72.0784 63.5784 72.8284 62.8284C73.5784 62.0784 74 61.0608 74 60V52",
    stroke: "url(#paint8_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 52V60C26 61.0608 26.4214 62.0784 27.1716 62.8284C27.9217 63.5784 28.9391 64 30 64H38",
    stroke: "url(#paint9_linear_7475_55003)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7475_55003",
    x1: 49.8182,
    y1: 31.8688,
    x2: 23.6876,
    y2: 40.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7475_55003",
    x1: 39.9318,
    y1: 52.9508,
    x2: 30.1329,
    y2: 56.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7475_55003",
    x1: 49.9318,
    y1: 52.9508,
    x2: 40.1329,
    y2: 56.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7475_55003",
    x1: 65.9318,
    y1: 26.9508,
    x2: 56.1329,
    y2: 30.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7475_55003",
    x1: 65.9318,
    y1: 40.9508,
    x2: 56.1329,
    y2: 44.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7475_55003",
    x1: 65.9318,
    y1: 52.9508,
    x2: 56.1329,
    y2: 56.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7475_55003",
    x1: 73.8636,
    y1: 21.9016,
    x2: 54.2657,
    y2: 28.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7475_55003",
    x1: 37.8636,
    y1: 21.9016,
    x2: 18.2657,
    y2: 28.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7475_55003",
    x1: 73.8636,
    y1: 57.9016,
    x2: 54.2657,
    y2: 64.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7475_55003",
    x1: 37.8636,
    y1: 57.9016,
    x2: 18.2657,
    y2: 64.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7475_55003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg88);
export default __webpack_public_path__ + "static/media/88.e681e3d7448b8ad84c86c3732d973d06.svg";
export { ForwardRef as ReactComponent };